// extracted by mini-css-extract-plugin
export var cardWrapper = "_4s-0";